export const TYPE_CITATIONS = 'citations'
export const TYPE_PLAGIARISM = 'plagiarism'
export const TYPE_EXPERT_CHECK = 'expert check'
export const TYPE_GRAMMAR = 'grammar'

export const HOMEPAGE_FEATURE_TOUR = 'homepage-feature-tour'
